<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Logs
            <v-spacer></v-spacer>
            <vc-date-picker
              mode='range'
              color="red"
              v-model='range'
              />
            <v-btn medium depressed flat icon color="white" 
              @click="fetchLogs()">
              <v-icon medium>cached</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-container fluid grid-list-xl>
              <v-layout row justify-center>
                <v-flex xs4>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    @keyup.enter="fetchLogs()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-combobox
                    label="Filter Levels"
                    clearable
                    small-chips
                    multiple
                    :items="levels"
                    v-model="filter"
                    v-on:change="fetchLogs()"
                  ></v-combobox>
                </v-flex>
              </v-layout>
            </v-container>
            <v-data-table
            :headers="headers"
            :items="items"
            :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
            :loading="logListLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.fileName}}</td>
                <td>{{ props.item.funcName}}</td>
                <td>{{ props.item.lineNo}}</td>
                <td>{{ props.item.module}}</td>
                <td>{{ props.item.level}}</td>
                <td>{{ props.item.createdDate | formatDate }}</td>
                <td>{{ props.item.message}}</td>
              </template>
              <template v-slot:body.append>
                <tr>
                  <td></td>
                  <td>
                    <v-select v-model="level" type="select" label="Level Filter"></v-select>
                  </td>
                  <td colspan="4"></td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'File Name', sortable: true, value: 'fileName'},
        {text: 'Function Name', sortable: true, value: 'funcName'},
        {text: 'Line', sortable: false, value: 'lineNo'},
        {text: 'Module', sortable: true, value: 'module'},
        {text: 'Level', sortable: true, value: 'level'},
        {text: 'Created Date', sortable: true, value: 'createdDate'},
        {text: 'Message', sortable: false, value: 'message'}
      ],
      levels: ['CRITICAL', 'ERROR', 'WARNING', 'INFO', 'DEBUG', 'NOTSET'],
      items: [],
      filter: [],
      range: {
        // default: last 7 days. fetchLogs() widens the picked days to 00:00:00 - 23:59:59,
        // the old default (start = the exact moment the page opened) hid every earlier log.
        start: new Date(new Date().setDate(new Date().getDate() - 7)),
        end: new Date()
      },
      logListLoading: false,
      pagination: {
        sortBy: 'id'
      },
      search: ''
    }
  },
  created () {
    this.logListLoading = true
    this.fetchLogs()
  },
  computed: {
    filteredItems() {
      return this.items.filter((r) => {
        return !this.filter || this.filter.length === 0 || (this.filter.includes(r.level))
      })
    }
  },
  methods: {
    fetchLogs () {
      this.items = []
      const start = new Date(this.range.start)
      start.setHours(0, 0, 0, 0)
      const end = new Date(this.range.end)
      end.setHours(23, 59, 59, 999)
      this.axios.get(`/logs/?q=${encodeURIComponent(this.search)}&start_date=${start.toJSON()}&end_date=${end.toJSON()}&filter=${this.filter}`)
        .then(response => {
          response.data.forEach(log => {
            let dataSources = []
            this.items.push({
              id: log.id,
              name: log.name,
              fileName: log.file_name,
              funcName: log.func_name,
              lineNo: log.line_no,
              module: log.module,
              level: log.level,
              message: log.message,
              createdDate: new Date(log.created_date)
            })
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.logListLoading = false
        })
    }
  }
}
</script>

<style>

</style>
